export default __webpack_public_path__ + "static/media/ElementaryClassroom.0e99129c.jpg";